'use client';

import styles from './CarSelection.module.scss';
import CarSelectionCarList from './CarList/CarSelectionList';

export default function CarSelection({ fields, id }) {
  // 从Sitecore fields获取数据
  const data = fields;

  // 调试输出

  // 尝试从不同路径获取数�?
  const title =
    data?.title?.value ||
    data?.title ||
    `<h2 class="${styles.title}">JAECOO <span>Car Selection</span></h2>`;
  const items = data?.carItem || data?.items || [];

  // 如果没有数据，显示提�?
  if (!items || items.length === 0) {
    return (
      <div className="container">
        <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
        <p>No car items available.</p>
        <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
          {JSON.stringify(fields, null, 2)}
        </pre>
      </div>
    );
  }

  return (
    <div className="container">
      <div dangerouslySetInnerHTML={{ __html: title }} />
      <CarSelectionCarList data={items} id={id} />
    </div>
  );
}
